__turbopack_context__.v({
  "fileUploadBoxDesign": "fileUploadBox-module__HgQNMG__fileUploadBoxDesign",
  "fileUploadBoxError": "fileUploadBox-module__HgQNMG__fileUploadBoxError",
  "grid": "fileUploadBox-module__HgQNMG__grid",
  "gridItems": "fileUploadBox-module__HgQNMG__gridItems",
  "iconBox": "fileUploadBox-module__HgQNMG__iconBox",
  "similarPdFBoxContentAlignment": "fileUploadBox-module__HgQNMG__similarPdFBoxContentAlignment",
  "subGrid": "fileUploadBox-module__HgQNMG__subGrid",
  "subGridItems": "fileUploadBox-module__HgQNMG__subGridItems",
  "title": "fileUploadBox-module__HgQNMG__title",
  "warrningText": "fileUploadBox-module__HgQNMG__warrningText",
});
